import { addAllToRecord, updateRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  FeedLoadFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import type {
  ThreadPinToMyLeadersFeedFulfilledAction,
  ThreadUnpinFromMyLeadersFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import type { NormalizedPinnedThreadEntities } from '../../../normalization/types';
import type { Thread } from '../../types';
import type { ThreadsPinnedToFeeds } from '../types';

export type ThreadsPinnedToMyLeadersFeedsAction =
  | FeedLoadFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | ThreadPinToMyLeadersFeedFulfilledAction
  | ThreadUnpinFromMyLeadersFeedFulfilledAction;

const initialState: ThreadsPinnedToFeeds = {};

const addPinnedThreadToMyLeadersFeed = (
  state: ThreadsPinnedToFeeds,
  entity: NormalizedPinnedThreadEntities['threadsPinnedToMyLeadersFeeds']
) => {
  if (!entity) {
    return state;
  }

  const arePinnedPosts = !!state.myLeaders;

  if (!arePinnedPosts) {
    return addAllToRecord(state, entity);
  }

  const currentPinnedThreads = state.myLeaders.threadIds;
  const newPinnedThreads = [...currentPinnedThreads, ...entity.myLeaders.threadIds];

  return updateRecord(state, 'myLeaders', { threadIds: newPinnedThreads });
};

const unpinThreadFromMyLeadersFeed = (state: ThreadsPinnedToFeeds, threadId: Thread['id']) => {
  const newPinnedThreads = state.myLeaders.threadIds.filter((id) => id !== threadId);

  return updateRecord(state, 'myLeaders', { threadIds: newPinnedThreads });
};

const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToMyLeadersFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToMyLeadersFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToMyLeadersFeeds);
    case 'THREAD.PIN_TO_MY_LEADERS_FULFILLED':
      return addPinnedThreadToMyLeadersFeed(state, action.payload.entities.threadsPinnedToMyLeadersFeeds);
    case 'THREAD.UNPIN_FROM_MY_LEADERS_FULFILLED':
      return unpinThreadFromMyLeadersFeed(state, action.payload.threadId);
    default:
      return state;
  }
};

export default reducer;
